import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
  standalone: true
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength = 50): string {
    if (!value) return '-';
    return value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
  }
}
